import { apiFetch } from "@/utils";
import { apiPostCustomBody } from ".";

function getAlerts(year, top) {
  return apiFetch(`datas/alerte-tx-rfa?year=${year}&top=${top}`);
}

function postCommentaire(commentaire, supplierGuid, visa, periodId) {
  let alertModelForUpdate = {
    "Commentaire": commentaire,
    "SupplierGuid": supplierGuid,
    "Visa": visa,
    "PeriodId": periodId
  };

  apiPostCustomBody("datas/alerte-tx-rfa", alertModelForUpdate);
}


export default {
  getAlerts,
  postCommentaire
}
export {
  getAlerts,
  postCommentaire
}



// WEBPACK FOOTER //
// ./src/utils/caRfa.js